export default __webpack_public_path__ + "static/media/card-gray.865fa88c.svg";